import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Power({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Power</title>
      <path
        d="M12.0044 3V11.9987M17.6578 7.17539C18.7763 8.30813 19.538 9.75121 19.8465 11.3222C20.1549 12.8931 19.9964 14.5214 19.3908 16.0011C18.7852 17.4808 17.7598 18.7455 16.4443 19.6353C15.1288 20.5251 13.5821 21 12 21C10.4179 21 8.87125 20.5251 7.55571 19.6353C6.24018 18.7455 5.21479 17.4808 4.60922 16.0011C4.00364 14.5214 3.84506 12.8931 4.15353 11.3222C4.462 9.75121 5.22367 8.30813 6.34222 7.17539"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
